import { render, staticRenderFns } from "./RoundedTextBox.vue?vue&type=template&id=de19071e&scoped=true&"
import script from "./RoundedTextBox.vue?vue&type=script&lang=js&"
export * from "./RoundedTextBox.vue?vue&type=script&lang=js&"
import style0 from "./RoundedTextBox.vue?vue&type=style&index=0&id=de19071e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de19071e",
  null
  
)

export default component.exports